// Minihearts personalization for Canopy 7.4 - port of the old theme's flow.
// "Stack a mini heart $6" (up to four). Each stacked heart is its own $6
// product line (variant ids come from data-variant-ids on the mount), and the
// chosen letter for each is stored as a line item property on the main
// product: First / Second / Third / Fourth Mini Heart. The extra heart lines
// are added to the cart right before the main product.
(function () {
  var LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var ORDINALS = ['First', 'Second', 'Third', 'Fourth'];
  var STACK_LABELS = ['Stack a mini heart', 'Stack a second mini heart', 'Stack a third mini heart', 'Stack a fourth mini heart'];

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var ids = (root.dataset.variantIds || '').split(',').filter(Boolean);
    var price = parseFloat(root.dataset.price || '6');
    var levels = [];

    root.appendChild(el('div', 'label anthology-extra__label', (root.dataset.step || '') + '. Minihearts'));

    ids.slice(0, 4).forEach(function (variantId, i) {
      var box = el('div', 'anthology-mh__level');
      var checkRow = el('label', 'anthology-mh__check');
      var check = document.createElement('input');
      check.type = 'checkbox';
      check.dataset.variantId = variantId;
      checkRow.appendChild(check);
      checkRow.appendChild(el('span', '', STACK_LABELS[i] + ' $' + price));

      var pick = el('div', 'anthology-mh__pick');
      pick.hidden = true;
      var selId = 'anthology-mh-select-' + i;
      var pickLabel = el('label', 'anthology-mh__pick-label', ORDINALS[i] + ' Mini Heart*');
      pickLabel.setAttribute('for', selId);
      var select = document.createElement('select');
      select.id = selId;
      select.name = 'properties[' + ORDINALS[i] + ' Mini Heart]';
      select.disabled = true;
      select.className = 'anthology-mh__select';
      var ph = el('option', '', '-- Choose ' + ORDINALS[i] + ' Mini Heart --');
      ph.value = '';
      select.appendChild(ph);
      LETTERS.forEach(function (c) {
        var o = el('option', '', c);
        o.value = c;
        select.appendChild(o);
      });
      pick.appendChild(pickLabel);
      pick.appendChild(select);

      var next = el('div', 'anthology-mh__next');
      box.appendChild(checkRow);
      box.appendChild(pick);
      box.appendChild(next);
      levels.push({ box: box, check: check, pick: pick, select: select, next: next, hostRow: checkRow });
    });

    // Chain the levels: level n+1 lives inside level n's expanded area and
    // only appears once level n is ticked (as on the old theme).
    levels.forEach(function (lvl, i) {
      if (i === 0) root.appendChild(lvl.box);
      else levels[i - 1].next.appendChild(lvl.box);
    });

    var total = el('div', 'anthology-mh__total');
    total.appendChild(document.createTextNode('Total Extras: '));
    var totalOut = el('span', 'anthology-mh__total-amount', '$0.00');
    total.appendChild(totalOut);
    var error = el('div', 'anthology-mh__error');
    error.setAttribute('role', 'alert');
    error.hidden = true;
    root.appendChild(total);
    root.appendChild(error);

    function activeLevels() {
      return levels.filter(function (l) { return l.check.checked; });
    }

    function refresh() {
      var prevOn = true;
      levels.forEach(function (lvl, i) {
        // a level can only be on if the one before it is on
        if (!prevOn && lvl.check.checked) lvl.check.checked = false;
        lvl.box.hidden = i > 0 && !prevOn;
        var on = lvl.check.checked;
        lvl.pick.hidden = !on;
        lvl.select.disabled = !on;
        if (!on) lvl.select.value = '';
        prevOn = on;
      });
      totalOut.textContent = '$' + (activeLevels().length * price).toFixed(2);
      error.hidden = true;
    }

    levels.forEach(function (lvl) {
      lvl.check.addEventListener('change', refresh);
      lvl.select.addEventListener('change', function () { error.hidden = true; });
    });

    // ---- form wiring: the block sits outside the main product <form> ----
    function mainForm() {
      return document.querySelector('form.js-product-form-main');
    }
    function associate() {
      var form = mainForm();
      var id = form && form.getAttribute('id');
      if (!id) return;
      levels.forEach(function (lvl) {
        if (lvl.select.getAttribute('form') !== id) lvl.select.setAttribute('form', id);
      });
    }
    associate();

    function firstMissing() {
      var picked = activeLevels();
      for (var i = 0; i < picked.length; i++) {
        if (!picked[i].select.value) return picked[i];
      }
      return null;
    }
    function showMissing(lvl) {
      error.textContent = 'Please choose a letter for each mini heart you add.';
      error.hidden = false;
      lvl.select.focus();
    }

    // Candy Rack opens its "Need anything else?" pop-up on the Add to bag
    // click, before the form submits - so check the letters here, first.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('form.js-product-form-main button[type="submit"], form.js-product-form-main button[name="add"]');
      if (!btn) return;
      var missing = firstMissing();
      if (missing) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMissing(missing);
      }
    }, true);

    var bypass = false;
    function onSubmit(e) {
      associate();
      if (bypass) { bypass = false; return; }
      var picked = activeLevels();
      if (!picked.length) return;

      // every ticked heart needs a letter
      var missing = firstMissing();
      if (missing) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMissing(missing);
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();
      var form = e.currentTarget;
      var submitter = e.submitter || null;

      var body = new URLSearchParams();
      picked.forEach(function (lvl, n) {
        body.append('items[' + n + '][id]', lvl.check.dataset.variantId);
        body.append('items[' + n + '][quantity]', '1');
      });

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString()
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          // hearts are in the cart; now let the normal add-to-bag run
          bypass = true;
          if (form.requestSubmit) form.requestSubmit(submitter || undefined);
          else form.submit();
        })
        .catch(function () {
          error.textContent = 'Sorry, we could not add your mini hearts. Please try again.';
          error.hidden = false;
        });
    }

    var form = mainForm();
    if (form) form.addEventListener('submit', onSubmit, true);

    refresh();
  }

  function boot() {
    document.querySelectorAll('[data-anthology-minihearts]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
